import { AmplifyProvider } from "@aws-amplify/ui-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import AuthenticatorWrapper from "./components/Utils/AuthenticatorWrapper";
import configureAuth from "./configureEnvironment/configureAuth";
import queryClient from "./queryClient";
import { routes } from "./routes";

export const shouldSkipAuth = () => process.env.REACT_APP_SKIP_AUTH === "SKIP";

if (!shouldSkipAuth()) {
  configureAuth();
}

const router = createBrowserRouter(routes);

function App() {
  return (
    <AmplifyProvider>
      <AuthenticatorWrapper>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#18181A",
                colorPrimaryHover: "#27272A",
              },
              components: {
                Button: {
                  fontWeight: "bold",
                },
                Input: {
                  inputFontSize: 16,
                },
              },
            }}
          >
            <RouterProvider router={router} />
          </ConfigProvider>
          {/* React Query Devtools only visible in development mode */}
          {window.location.hostname === "localhost" && <ReactQueryDevtools />}
        </QueryClientProvider>
      </AuthenticatorWrapper>
    </AmplifyProvider>
  );
}

export default App;
